import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PlayButton from "../components/PlayButton"
import PauseButton from "../components/PauseButton"
import ReactPlayer from 'react-player'
import Img from "gatsby-image"
import Header from "./../components/header"

export default class Audio extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      playing: false,
      progress: 0,
      playedInfo: '00:00',
      totalInfo: '00:00',
    }
  }

  handleEnded = (data) => {
    this.setState((state, props) => ({
      progress: 0,
      playing: false,
    }));
  }

  handleProgress = (data) => {
    if (data.played) {
      let minutes = Math.floor(data.playedSeconds / 60);
      let seconds = Math.floor(data.playedSeconds % 60);
      if (data.played === 1) {
        this.setState((state, props) => ({
          progress: 0,
          playedInfo: '00:00',
        }));
      } else {
        this.setState((state, props) => ({
          progress: data.played,
          playedInfo: this.strPad(minutes,'0', 2) + ':' + this.strPad(seconds,'0',2),
        }));
      }
    }
  }

  handleDuration = (data) => {
    let minutes = Math.floor(data / 60);
    let seconds = data % 60;
    this.setState((state, props) => ({
      totalInfo: this.strPad(minutes,'0', 2) + ':' + this.strPad(seconds,'0',2),
    }));
  }

  strPad = (string, pad, length) => {
    return (new Array(length+1).join(pad)+string).slice(-length);
  }

  switchPlay = () => {
    this.setState((state, props) => ({
      playing: !state.playing
    }));
  }

  render() {
    const node = this.props.data.markdownRemark;
    const progress = Math.floor(this.state.progress * 100);
    return (
      <Layout>
        <SEO title={node.frontmatter.title} />
        <Header title="Retour" href="/hent" />
        <div className="audio-page">
          <Img
            className="cover"
            fluid={node.frontmatter.img.childImageSharp.fluid}
            imgStyle={{ objectFit: 'contain' }}
          />

          <h1>{node.frontmatter.title}</h1>

          <div className="timeline-wrapper">
            <div className="played-info">{ this.state.playedInfo }</div>
            <div className="timeline">
              <div className="timeline-progress" style={{width: progress + '%'}}>
              </div>
            </div>
            <div className="total-info">{ this.state.totalInfo }</div>
          </div>

          <div className="play-control">
            {this.state.playing ? <PauseButton onPlayerClick={this.switchPlay} /> : <PlayButton onPlayerClick={this.switchPlay} />}
          </div>

          <div dangerouslySetInnerHTML={{ __html: node.html }} />

          <ReactPlayer
            url={node.frontmatter.mp3}
            playing={this.state.playing}
            controls={false}
            style={{display: 'none'}}
            onProgress={this.handleProgress}
            onEnded={this.handleEnded}
            onDuration={this.handleDuration}
          />
        </div>
      </Layout>
    )
  }
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        mp3
        img {
          childImageSharp {
            fixed(width:300) {
              ...GatsbyImageSharpFixed
            }
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
